import React from "react";
import { motion } from "framer-motion";
import "./PageHeader.css";

function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="page-header">
      <div className="page-header__grain" aria-hidden="true" />
      <div className="container">
        <motion.span
          className="eyebrow"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {eyebrow}
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {subtitle && (
          <motion.p
            className="page-header__subtitle"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}

export default PageHeader;
